import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

interface KeyValueRow {
  key: string;
  valueType: string;
  value: string;
}

@Component({
  selector: 'app-key-value-editor',
  templateUrl: './key-value-editor.component.html',
  styleUrls: ['./key-value-editor.component.scss']
})
export class KeyValueEditorComponent implements OnChanges {

  @Input() data: any;
  @Input() keyPlaceholder = 'key';
  @Output() dataChange = new EventEmitter<any>();

  valueTypes = ['string', 'number', 'boolean', 'null', 'json'];

  rows: KeyValueRow[] = [];

  private lastEmitted: any;

  ngOnChanges(changes: SimpleChanges): void {
    // Only re-parse when the change came from outside, not from our own emit
    if (changes.data && changes.data.currentValue !== this.lastEmitted) {
      this.parseData();
    }
  }

  parseData() {
    this.rows = [];

    if (!this.data || typeof this.data !== 'object') {
      return;
    }

    for (const key of Object.keys(this.data)) {
      const value = this.data[key];

      if (value !== null && typeof value === 'object') {
        this.rows.push({ key, valueType: 'json', value: JSON.stringify(value) });
      } else if (typeof value === 'number') {
        this.rows.push({ key, valueType: 'number', value: String(value) });
      } else if (typeof value === 'boolean') {
        this.rows.push({ key, valueType: 'boolean', value: String(value) });
      } else if (value === null) {
        this.rows.push({ key, valueType: 'null', value: '' });
      } else {
        this.rows.push({ key, valueType: 'string', value: String(value) });
      }
    }
  }

  addRow() {
    this.rows.push({ key: '', valueType: 'string', value: '' });
  }

  removeRow(index: number) {
    this.rows.splice(index, 1);
    this.emitData();
  }

  emitData() {
    const data: any = {};

    for (const row of this.rows) {
      if (!row.key) {
        continue;
      }

      switch (row.valueType) {
        case 'number':
          data[row.key] = parseFloat(row.value);
          break;
        case 'boolean':
          data[row.key] = row.value.trim().toLowerCase() === 'true';
          break;
        case 'null':
          data[row.key] = null;
          break;
        case 'json':
          try {
            data[row.key] = JSON.parse(row.value);
          } catch (err) {
            // Invalid JSON, skip this row until it parses
          }
          break;
        default:
          data[row.key] = row.value;
      }
    }

    this.data = data;
    this.lastEmitted = data;
    this.dataChange.emit(data);
  }
}
